import React from "react";
import "./Dev.css";
import CircleScrollKartik from "../CircleScroll/CircleScrollKartik";
import CircleScrollBiswa from "../CircleScroll/CircleScrollBiswa";
import { useState, useEffect } from "react";

const Dev = ({ devImg, devRole, devName, devDesc, portfolioHREF }) => {
  const [popVisible, setPopVisible] = useState(false);

  useEffect(() => {
    const width = window.innerWidth;

    if (width > 768) {
      const showPop = () => {
        setPopVisible(true);
      };
      const popUpTimer = setTimeout(showPop, 5000);
      function myStopFunction() {
        clearTimeout(popUpTimer);
      }
    }
  }, []);

  return (
    <div className="devs" id="devs">
      <div className="avatarContainer">
        <div className="devs-image">
          <img src={devImg} alt="devs" className="devs-image" />
        </div>
        <span className={`${popVisible ? "popup-text-show" : "popup-text"}`}>
          Try Clicking!
        </span>

        <div className="scrollContainer" onClick={() => setPopVisible(false)}>
          {devName === "Kartik Jha" ? (
            <>
              <CircleScrollKartik
                className="scroll-component"
                devImg={devImg}
              />
            </>
          ) : (
            <>
              <CircleScrollBiswa className="scroll-component" devImg={devImg} />
            </>
          )}
        </div>
      </div>
      <div className="devs-content">
        <h1 className="gradient__text devName">
          {devName} <br />
        </h1>
        <h4 className="devHeading">{devRole}</h4>

        <a className="button" target="_blank" href={portfolioHREF}>
          See Portfolio
        </a>
      </div>
    </div>
  );
};

export default Dev;
